module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_0@2x.e11c270d.png";